import Vue from 'vue';
import Router from 'vue-router';
import Login from './views/Login.vue';
import Home from './views/Home.vue';
import Profile from './views/Profile.vue';
import SettingProfile from './views/SettingProfile.vue';
import Message from './views/Message.vue';
import Administrator from './views/Administrator.vue';
import Search from './views/Search.vue';
import Notification from './views/Notification.vue';
import Page401 from './views/Page401.vue';
import Page404 from './views/Page404.vue';
import BootstrapVue from 'bootstrap-vue';

Vue.use(Router, BootstrapVue);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login,
      meta: {
        on: 'login',
        title: 'Welcome to DarmaSocmed',
      },
    },
    {
      path: '/admin/:type',
      name: 'administrator',
      component: Administrator,
      meta: {
        requiresAuth: true,
        title: 'DarmaSocmed - Administrator',
      },
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
      meta: {
        requiresAuth: true,
        title: 'DarmaSocmed - Newsfeed',
      },
    },
    {
      path: '/profile/:id/:type',
      name: 'visit-profile',
      component: Profile,
      meta: {
        requiresAuth: true,
        title: 'DarmaSocmed - Profile',
      },
    },
    {
      path: '/profile/:type',
      name: 'profile',
      component: Profile,
      meta: {
        requiresAuth: true,
        title: 'DarmaSocmed - Profile',
      },
    },
    {
      path: '/setting-profile',
      name: 'setting-profile',
      component: SettingProfile,
      meta: {
        requiresAuth: true,
        title: 'DarmaSocmed - Setting Profile',
      },
    },
    {
      path: '/message',
      name: 'message',
      component: Message,
      meta: {
        requiresAuth: true,
        title: 'DarmaSocmed - Message',
      },
    },
    {
      path: '/search/:q',
      name: 'search',
      component: Search,
      meta: {
        requiresAuth: true,
        title: 'DarmaSocmed - Search User',
      },
    },
    {
      path: '/notification',
      name: 'notification',
      component: Notification,
      meta: {
        requiresAuth: true,
        title: 'DarmaSocmed - Notification',
      },
    },
    {
      path: '/401',
      name: '401',
      component: Page401,
      meta: {
        title: '401 - Unauthorized Access',
      },
    },
    {
      path: '*',
      name: '404',
      component: Page404,
      meta: {
        title: '404 - Page Not Found',
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (typeof localStorage.getItem('dataUser') !== 'undefined' && localStorage.getItem('dataUser') !== null) {    
      next();
    } else {
      next({
        path: '/401',
      });
    }
  } else {
    if (typeof localStorage.getItem('dataUser') !== 'undefined' && localStorage.getItem('dataUser') !== null && to.matched.some(record => record.meta.on === 'login')) {
      next({
        path: '/home',
      }); 
    } else {
      next();
    }
  }
});

export default router;
